import React, { useState } from 'react';

import HighlightText from '@components/highlight-text';

import style from './body.module.scss';

const stripHtml = (html) => html?.replace(/<[^>]*>/g, '') || '';

const BodyDescription = ({ description, highlight }) => {
  const [expanded, setExpanded] = useState(false);

  const plainText = stripHtml(description);

  const isExpandable = plainText?.length > 169 || /<br\s*\/?>/i.test(description);

  const handleExpandClick = (e) => {
    if (isExpandable) {
      e.stopPropagation();
      setExpanded(!expanded);
    }
  };
  return (
    <div className={style.description}>
      <p className={expanded ? style.expanded : style.collapsed} onClick={handleExpandClick}>
        <HighlightText text={description} highlight={highlight} dangerouslySetInnerHTML />
      </p>
    </div>
  );
};

export default BodyDescription;
